var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Component, Inject, Vue } from 'vue-property-decorator';
import { Talent } from 'packages/talent/entities/Talent';
import UiRadioButton from 'ui/v1/controls/UiRadioButton.vue';
import { CallLog, CallLogAction, CallLogOutcomes } from 'packages/call_logs/CallLog';
import { CallLogRepository } from 'packages/call_logs/CallLogRepository';
import { container } from 'tsyringe';
import { EntityBuilder } from '@decahedron/entity';
import { Getter, namespace, State } from 'vuex-class';
import { Job } from 'packages/v3/jobs/Job';
import { Candidate, CandidateCategory } from '@/packages/v3/jobs/Candidate';
import { FeatureConfiguration } from 'packages/features/FeatureConfiguration';
var jobsModule = namespace('jobs');
var callLogsModule = namespace('callLogs');
var talentCardModule = namespace('talentCard');
var talentCommentModule = namespace('talentCard/talentCommentState');
var CallLogsCreate = /** @class */ (function (_super) {
    __extends(CallLogsCreate, _super);
    function CallLogsCreate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.repo = container.resolve(CallLogRepository);
        _this.callLogAction = CallLogAction.DO_NOTHING;
        _this.callLog = EntityBuilder.buildOne(CallLog, {
            outcome: CallLogOutcomes.QUALIFIED,
        });
        _this.creatingCallLog = false;
        return _this;
    }
    Object.defineProperty(CallLogsCreate.prototype, "nextPipelineStage", {
        get: function () {
            var _this = this;
            var currentStage = this.job.stages.find(function (stage) { return stage.id === _this.candidate.pipelineStage; });
            return this.job.stages.find(function (stage) { return stage.position === currentStage.position + 1; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CallLogsCreate.prototype, "jobId", {
        get: function () {
            var _a;
            return parseInt((_a = this.$route.params) === null || _a === void 0 ? void 0 : _a.jobId, 10) || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CallLogsCreate.prototype, "listOfOutcomes", {
        get: function () {
            var _a;
            return _a = {},
                _a[CallLogOutcomes.QUALIFIED] = this.$t('call_logs.outcomes.qualified'),
                _a[CallLogOutcomes.UNQUALIFIED] = this.$t('call_logs.outcomes.unqualified'),
                _a[CallLogOutcomes.BUSY] = this.$t('call_logs.outcomes.busy'),
                _a[CallLogOutcomes.UNREACHABLE] = this.$t('call_logs.outcomes.unreachable'),
                _a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CallLogsCreate.prototype, "calloutMessageForOutcome", {
        get: function () {
            switch (this.callLog.outcome) {
                case CallLogOutcomes.UNQUALIFIED:
                    return this.$t('call_logs.callout_messages.unqualified');
                case CallLogOutcomes.BUSY:
                    return this.$t('call_logs.callout_messages.busy');
                case CallLogOutcomes.UNREACHABLE:
                    return this.$t('call_logs.callout_messages.unreachable');
                default:
                    return this.$t('call_logs.callout_messages.qualified');
            }
        },
        enumerable: false,
        configurable: true
    });
    CallLogsCreate.prototype.isCandidateInRejectedStage = function () {
        return this.candidate.pipelineStage === this.job.stages[this.job.stages.length - 1].id;
    };
    CallLogsCreate.prototype.isCandidateInQualifiedStage = function () {
        return this.candidate.pipelineStage === this.job.stages[this.job.stages.length - 2].id;
    };
    Object.defineProperty(CallLogsCreate.prototype, "callLogActionsBasedOnOutcome", {
        get: function () {
            if (this.isCandidateInRejectedStage() || this.isCandidateInQualifiedStage()) {
                return CallLogAction.DO_NOTHING;
            }
            switch (this.callLog.outcome) {
                case CallLogOutcomes.UNQUALIFIED:
                    return CallLogAction.REJECT_CANDIDATE;
                case CallLogOutcomes.QUALIFIED:
                    return CallLogAction.MOVE_CANDIDATE;
                default:
                    return CallLogAction.DO_NOTHING;
            }
        },
        enumerable: false,
        configurable: true
    });
    CallLogsCreate.prototype.createCallLog = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function () {
            var pipelineStageId, newCallLog, _h;
            var _this = this;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        this.creatingCallLog = true;
                        pipelineStageId = this.candidate.pipelineStage;
                        this.callLogAction = this.callLogActionsBasedOnOutcome;
                        newCallLog = EntityBuilder.buildOne(CallLog, {
                            outcome: this.callLog.outcome,
                            jobId: this.jobId,
                            talentId: this.talent.id,
                            action: this.callLogAction,
                            pipelineStageId: this.callLogAction === CallLogAction.MOVE_CANDIDATE ? (_a = this.nextPipelineStage) === null || _a === void 0 ? void 0 : _a.id : null,
                            comment: this.callLog.comment,
                        });
                        _h = this;
                        return [4 /*yield*/, this.repo.create(newCallLog, {
                                job: this.jobId,
                                talent: this.talent.id,
                            })];
                    case 1:
                        _h.callLog = _j.sent();
                        this.$posthog.capture('Call logged', {
                            callOutcome: this.callLog.outcome,
                            category: CandidateCategory[(_b = this.candidate.category) !== null && _b !== void 0 ? _b : 0],
                            pipelineStageType: (_c = this.job.stages.find(function (stage) { return stage.id === _this.candidate.pipelineStage; })) === null || _c === void 0 ? void 0 : _c.type,
                            timeCreated: this.candidate.createdAt,
                            hoursInFunnel: this.candidate.hoursInFunnel,
                        });
                        if (this.callLog.outcome === CallLogOutcomes.UNQUALIFIED) {
                            pipelineStageId = (_e = (_d = this.job.stages[this.job.stages.length - 1]) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : this.candidate.pipelineStage;
                        }
                        if (this.callLog.outcome === CallLogOutcomes.QUALIFIED) {
                            pipelineStageId = this.isCandidateInQualifiedStage()
                                ? this.candidate.pipelineStage
                                : (_g = (_f = this.nextPipelineStage) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : this.candidate.pipelineStage;
                        }
                        this.candidate.pipelineStage = pipelineStageId;
                        this.setCallLogs(__spreadArray([
                            this.callLog
                        ], this.callLogs));
                        this.getComments({
                            talentId: this.talent.id,
                            jobId: this.jobId,
                        });
                        this.getCommenters({
                            talentId: this.talent.id,
                            jobId: this.jobId,
                        });
                        this.candidate.callLogs.unshift(newCallLog);
                        this.updateCandidate(this.candidate);
                        this.creatingCallLog = false;
                        return [4 /*yield*/, this.$router.push({
                                name: this.routeNamePrefix + "TalentCard.CallLogs.Index",
                            })];
                    case 2:
                        _j.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    var _a, _b, _c, _d;
    __decorate([
        Inject(),
        __metadata("design:type", String)
    ], CallLogsCreate.prototype, "routeNamePrefix", void 0);
    __decorate([
        State,
        __metadata("design:type", typeof (_a = typeof FeatureConfiguration !== "undefined" && FeatureConfiguration) === "function" ? _a : Object)
    ], CallLogsCreate.prototype, "features", void 0);
    __decorate([
        Getter,
        __metadata("design:type", Boolean)
    ], CallLogsCreate.prototype, "candidateIsolationEnabledOrNil", void 0);
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_b = typeof Candidate !== "undefined" && Candidate) === "function" ? _b : Object)
    ], CallLogsCreate.prototype, "candidate", void 0);
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_c = typeof Talent !== "undefined" && Talent) === "function" ? _c : Object)
    ], CallLogsCreate.prototype, "talent", void 0);
    __decorate([
        callLogsModule.State,
        __metadata("design:type", Array)
    ], CallLogsCreate.prototype, "callLogs", void 0);
    __decorate([
        callLogsModule.Mutation,
        __metadata("design:type", Function)
    ], CallLogsCreate.prototype, "setCallLogs", void 0);
    __decorate([
        talentCommentModule.Action,
        __metadata("design:type", Function)
    ], CallLogsCreate.prototype, "getComments", void 0);
    __decorate([
        talentCommentModule.Action,
        __metadata("design:type", Function)
    ], CallLogsCreate.prototype, "getCommenters", void 0);
    __decorate([
        jobsModule.State,
        __metadata("design:type", typeof (_d = typeof Job !== "undefined" && Job) === "function" ? _d : Object)
    ], CallLogsCreate.prototype, "job", void 0);
    __decorate([
        jobsModule.Mutation,
        __metadata("design:type", Function)
    ], CallLogsCreate.prototype, "updateCandidate", void 0);
    CallLogsCreate = __decorate([
        Component({
            components: { UiRadioButton: UiRadioButton },
        })
    ], CallLogsCreate);
    return CallLogsCreate;
}(Vue));
export default CallLogsCreate;
